import { CATEGORIES } from '@kijiji/category'

const HOMEPAGE_NAV_BASE_URL = `/next-assets/images/homepage/navigation`

const CATEGORY_TO_IMAGE: { [categoryId: number]: string } = {
  [CATEGORIES.BUY_AND_SELL_CATEGORY_ID]: `${HOMEPAGE_NAV_BASE_URL}/L1_buy_and_sell.jpg`,
  [CATEGORIES.CARS_AND_VEHICLES_CATEGORY_ID]: `${HOMEPAGE_NAV_BASE_URL}/L1_cars_and_vehicles.jpg`,
  [CATEGORIES.COMMUNITY_CATEGORY_ID]: `${HOMEPAGE_NAV_BASE_URL}/L1_community.jpg`,
  [CATEGORIES.JOBS_CATEGORY_ID]: `${HOMEPAGE_NAV_BASE_URL}/L1_jobs.jpg`,
  [CATEGORIES.PETS_CATEGORY_ID]: `${HOMEPAGE_NAV_BASE_URL}/L1_pets.jpg`,
  [CATEGORIES.REAL_ESTATE_CATEGORY_ID]: `${HOMEPAGE_NAV_BASE_URL}/L1_real_estate.jpg`,
  [CATEGORIES.SERVICES_CATEGORY_ID]: `${HOMEPAGE_NAV_BASE_URL}/L1_services.jpg`,
  [CATEGORIES.VACATION_RENTALS_CATEGORY_ID]: `${HOMEPAGE_NAV_BASE_URL}/L1_vacation_rentals.jpg`,
}

export const getMenuCategoryImage = (categoryId: number): string => {
  return CATEGORY_TO_IMAGE[categoryId]
}
